import { createReducer, on } from '@ngrx/store';
import { initialState } from './list-officer-store.state';
import * as ListOfficerActions from './list-officer-store.actions';
import { ActionType, ListOfficerActionResult } from '../models/list-officer-action-result.models';

export const listOfficerReducer = createReducer(
  initialState,
  on(ListOfficerActions.listOfficerSuccess, (state, result) => ({
    ...state,
    officers: result.officers,
    isLoading: false,
  })),
  on(ListOfficerActions.listOfficer, (state) => ({
    ...state,
    isLoading: true,
  })),
  on(ListOfficerActions.listPaginationOfficersSuccess, (state, result) => ({
    ...state,
    paginationOfficers: result.paginationOfficers,
    query: result.query,
    filteredOfficersTotalCount: result.filteredOfficersTotalCount,
    isLoading: false,
  })),
  on(ListOfficerActions.listPaginationOfficers, (state) => ({
    ...state,
    isLoading: true,
  })),
  on(ListOfficerActions.deleteOfficer, (state) => ({
    ...state,
    isLoading: true,
  })),
  on(ListOfficerActions.deleteOfficerSuccess, (state, { uid }) => {
    const updatedOfficers = [...state.officers.filter((x) => x.uid !== uid)];
    const updatedPaginationOfficers = [...state.paginationOfficers.filter((x) => x.uid !== uid)];

    return {
      ...state,
      officers: updatedOfficers,
      paginationOfficers: updatedPaginationOfficers,
      filteredOfficersTotalCount: state.filteredOfficersTotalCount - 1,
      actionResult: new ListOfficerActionResult(ActionType.DeleteOfficer, '', true),
      isLoading: false,
    };
  }),
  on(ListOfficerActions.listOfficerActionResult, (state, { actionResult }) => {
    return {
      ...state,
      actionResult: actionResult,
      isLoading: false,
    };
  }),
  on(ListOfficerActions.inviteUser, (state, { uid }) => ({
    ...state,
    officers: state.officers.map((officer) => (officer.uid === uid ? { ...officer, isInviting: true } : officer)),
    paginationOfficers: state.paginationOfficers.map((officer) => (officer.uid === uid ? { ...officer, isInviting: true } : officer)),
  })),
  on(ListOfficerActions.inviteUserSuccess, (state, { uid }) => ({
    ...state,
    officers: state.officers.map((officer) => (officer.uid === uid ? { ...officer, isInviting: false, inviteSent: true } : officer)),
    paginationOfficers: state.paginationOfficers.map((officer) => (officer.uid === uid ? { ...officer, isInviting: false, inviteSent: true } : officer)),
    actionResult: new ListOfficerActionResult(ActionType.InviteUser, '', true),
  })),
  on(ListOfficerActions.inviteUserFail, (state, { uid, error }) => ({
    ...state,
    officers: state.officers.map((officer) => (officer.uid === uid ? { ...officer, isInviting: false } : officer)),
    paginationOfficers: state.paginationOfficers.map((officer) => (officer.uid === uid ? { ...officer, isInviting: false } : officer)),
    actionResult: new ListOfficerActionResult(ActionType.InviteUser, error, false),
  }))
);
